<template>
  <div class="store-widget-v3-edit">
    <menu-item label="背景设置">
      <menu-fill :target="model.background" target-key="background" />
      <menu-background-image class="mt-2" :target="model.background" target-key="background" />
    </menu-item>
  
    <menu-item label="布局">
      <menu-switch v-model="model.titleVisible" label="标题" />
      <menu-switch v-model="model.describeVisible" label="描述" />
    </menu-item>
    <nav-edit class="mt-4" label="提示按钮跳转事件" :site="site" :target="model.nav" />
    <menu-item label="商品分类">
      <im-select v-model="model.classId" class="w-full" size="small" placeholder="请选择" :options="$store.state.goods.groupList" />
    </menu-item>
    <menu-item label="卡片背景">
      <menu-background-image :target="model.cardBackground" target-key="cardBackground" />
    </menu-item>
    <menu-item label="卡片背景选中状态">
      <menu-background-image :target="model.activeCardBackground" target-key="activeCardBackground" />
    </menu-item>
    <menu-item label="文字颜色">
      <menu-fill :target="model.textColor" solid-color target-key="textColor" />
    </menu-item>
    <menu-item label="价格文字色">
      <menu-fill :target="model.priceColor" solid-color target-key="priceColor" />
    </menu-item>
    <menu-item label="按钮填充色">
      <menu-fill :target="model.buttonBackground" solid-color target-key="buttonBackground" />
    </menu-item>
    <menu-item label="按钮文字色">
      <menu-fill :target="model.buttonColor" solid-color target-key="buttonColor" />
    </menu-item>
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import MenuItem from '~/components/menu/menuItem.vue'
import MenuFill from '~/components/menu/menuFill.vue'
import RemoveBtn from '~/components/common/RemoveBtn.vue'
import MenuSwitch from '~/components/menu/menuSwitch.vue'
import MenuBackgroundImage from '~/components/menu/menuBackgroundImage.vue'
import ImSelect from '~/components/common/ImSelect.vue'
import NavEdit from '~/site/components/navEdit.vue'

export default {
  components: { NavEdit, ImSelect, MenuBackgroundImage, MenuSwitch, RemoveBtn, MenuFill, MenuItem },
  props: {
    model: Object,
    site: Object
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="less">
</style>
